import React from 'react';

import cn from 'classnames';
import { FormattedHTMLMessage } from 'react-intl';

import { Card, T } from '@shared/components';

import styles from './ScoutbookAd.less';
import BgDesktopImg from './assets/bg_desktop2.png';
import BgMobileImg from './assets/bg_mobile2.png';
import LogoImg from './assets/logo2.png';

const ScoutbookAd: React.FC<{ className?: string }> = ({ className }) => (
  <Card className={cn(styles.card, className)} noPadding shadow>
    <div className={styles.container}>
      <img src={BgDesktopImg} className={styles.bgDesktop} />
      <div className={styles.bar}>
        <img src={LogoImg} />
      </div>
      <div className={styles.titleAndButton}>
        <T serif size="4" className={styles.title}>
          <FormattedHTMLMessage id="user.ScoutbookAd.title" />
        </T>
      </div>
      <img src={BgMobileImg} className={styles.bgMobile} />
    </div>
  </Card>
);

export default ScoutbookAd;
